import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import * as propertyActions from "../../../../../actionCreators/Property";
import * as dropDownActions from "../../../../../actionCreators/DropDown";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import { Polygon } from "@react-google-maps/api";
import { Form, Row, Col, Select, Button } from "antd";
import { ExclamationCircleOutlined, CloseOutlined } from "@ant-design/icons";

import "../style/searchProperties.css";
import { doPost } from "../../../../../utils/request";

const { Option } = Select;

const MLEngine = ({
  getEtoCircles,
  highways,
  getHighways,
  Mlproperties,
  getMlProperties,
  mlEngineProperties,
  getMlEngineProperties,
}) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const [circle, setCircle] = React.useState(null);
  const [highway, setHighway] = React.useState(null);
  const [response, setResponse] = React.useState(false);
  const [showPolygon, setShowPolygon] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const [showMsg, setShowMsg] = React.useState(false);
  const [paths, setPaths] = useState([]);
  let lat_lng = [];
  const [center, setCenter] = React.useState(null);

  const containerStyle = {
    width: "100%",
    height: "400px",
  };
  const options = {
    fillColor: "rgba(33, 150, 243, 0.4)",
    fillOpacity: 0.4,
    strokeColor: "rgba(33, 150, 243, 1)",
    strokeOpacity: 1,
    strokeWeight: 1,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };
  React.useEffect(() => {
    getMlProperties();
  }, []);
  React.useEffect(() => {
    var temp = [];
    if (mlEngineProperties.data.length > 0) {
      mlEngineProperties.data.map((data) => {
        if (data?.new_property) {
          data?.polygon_lat_long?.map((value) => {
            let obj = {
              lat: value[0],
              lng: value[1],
            };
            lat_lng.push(obj);
          });
          temp.push(lat_lng);
          lat_lng = [];
          let cnt = {
            lat: parseFloat(data.latitude),
            lng: parseFloat(data.longitude),
          };
          setCenter({ ...cnt });
          setPaths([...temp]);
        }
      });
      setShowPolygon(true);
    }
  }, [mlEngineProperties]);

  const handleFinish = async (values) => {
    if (highway) {
      const data = {
        highway_id: highway,
      };
      setResponse(true);
      await doPost("/properties/detect", data)
        .then((response) => {
          setMessage(response.data.message);
          setShowMsg(true);
          getMlEngineProperties({ highway_id: highway });
          setResponse(false);
        })
        .catch((err) => {
        });
    }
  };
  const handleViewProperties = () => {
    history.push("/detected/all");
  };
  React.useEffect(() => {
    getEtoCircles();
    getHighways();
  }, []);
  const onLoad = (polygon) => {};
  return (
    <div>
      <Row gutter={[0, 16]}>
        <Col span={11}>
          <Form onFinish={handleFinish} form={form}>
            <Row className="mldropDown">
              <Col span={24}>
                <Form.Item name="highway_id">
                  <Select
                    placeholder="Highway Name"
                    size="large"
                    value={highway}
                    // disabled={highways?.data ? false : true}
                    className="select-field"
                    allowClear
                    onChange={(event) => {
                      setHighway(event);
                    }}
                    loading={highways?.data ? false : true}
                  >
                    {highways?.data?.map((type) => (
                      <Option key={type.id} value={type.id}>
                        {type.code !== null && type.code !==''? (
                          <>{type.name + " - " + type?.code}</>
                        ) : (
                          <>{type?.name}</>
                        )}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                {response ? (
                  <Button htmlType="submit" className="mlButton" disabled>
                    Detecting...
                  </Button>
                ) : (
                  <Button
                    htmlType="submit"
                    className="mlButton"
                    disabled={highway ? false : true}
                  >
                    START PROPERTY DETECTION
                  </Button>
                )}
              </Col>
            </Row>
            {showMsg ? (
              <Row>
                <Col span={24} className="mlMsg">
                  <div>
                    <span className="mlcon">
                      <ExclamationCircleOutlined />
                    </span>
                    <span className="mlText">{message}</span>
                  </div>
                  <div>
                    <span className="viewBtn" onClick={handleViewProperties}>
                      VIEW
                    </span>
                    <span
                      onClick={() => {
                        setShowMsg(false);
                      }}
                    >
                      <CloseOutlined />
                    </span>
                  </div>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Form>
        </Col>
        <Col span={1}></Col>
        <Col span={12}>
          <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={
                center
                  ? center
                  : { lat: 30.731968415207916, lng: 73.29509480653017 }
              }
              zoom={17}
            >
              {showPolygon ? (
                paths.map((data, index) => (
                  <Polygon
                    paths={data}
                    options={options}
                    onLoad={onLoad}
                    key={index}
                  />
                ))
              ) : (
                <></>
              )}
            </GoogleMap>
          </LoadScript>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = ({
  dropDown: { highways, etoCircles },
  property: { Mlproperties, mlEngineProperties },
}) => ({
  highways,
  etoCircles,
  Mlproperties,
  mlEngineProperties,
});

const mapDispatchToProps = (dispatch) => ({
  getEtoCircles: bindActionCreators(dropDownActions.getEtoCircles, dispatch),
  getHighways: bindActionCreators(dropDownActions.getHighways, dispatch),
  getMlProperties: bindActionCreators(
    propertyActions.getMlProperties,
    dispatch
  ),
  getMlEngineProperties: bindActionCreators(
    propertyActions.getMlEngineProperties,
    dispatch
  ),
});

MLEngine.propTypes = {
  getHighways: PropTypes.func.isRequired,
  getEtoCircles: PropTypes.func.isRequired,
  Mlproperties: PropTypes.object.isRequired,
  getMlProperties: PropTypes.func.isRequired,
  getMlEngineProperties: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MLEngine);
